import tracker, { DioContext, DioType } from './init';
/**
 * BI tracking events for the suspended user
 */
export default {
  userIsSuspended: (dayOfTrial: number) => {
    tracker.track(
      'suspended_login_redirect',
      DioType.PAGEVIEW,
      { dayOfTrial },
      DioContext.PORTER_CREDIT_CARD
    );
  },
  viewLoginPage() {
    tracker.track(
      'view_login_page',
      DioType.PAGEVIEW,
      {},
      DioContext.PORTER_LOGIN_PAGE
    );
  },
  loginPageClickLogin() {
    tracker.track(
      'click_login_page',
      DioType.CLICK,
      {},
      DioContext.PORTER_LOGIN_PAGE
    );
  },
};
